import { render, staticRenderFns } from "./main.vue?vue&type=template&id=4ee8ff00&scoped=true&lang=pug&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=4ee8ff00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee8ff00",
  null
  
)

/* custom blocks */
import block0 from "~/lang/user?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230602131631%2Fcomponents%2Fsite%2Fnav%2Fmain.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./main.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteNavBusinesshours: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/site/nav/businesshours.vue').default,SiteNavAccessibility: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/site/nav/accessibility.vue').default,SiteNavUtil: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/site/nav/util.vue').default,SiteNavDynamic: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/site/nav/dynamic.vue').default})
